import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { UserProfileDto, ResponseDto } from "@mimber/schema"
import { profileKeys } from "../profile.utils"

/**
 * Organization user-specific hook for managing profile data
 * Can only be used in mimber-organization app
 */
export const useProfile = (
  options?: UseQueryOptions<ResponseDto<UserProfileDto>, Error>
): UseQueryResult<ResponseDto<UserProfileDto>, Error> => {
  guardAppUsage("mimber-organization", "useProfile")

  const { server } = useServerContext()

  return useQuery({
    queryKey: profileKeys.getProfile(),
    queryFn: async () => {
      const response = await server.get<ResponseDto<UserProfileDto>>("profile")
      return response.data
    },
    ...options,
  })
}
